import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "Est-ce un conseil en investissement ?",
    a: `Non. Je partage mes propres décisions et mes raisons. Je ne te dis pas quoi acheter, et je ne réponds pas aux situations individuelles.`,
  },
  {
    q: "Comment j'accède à l'espace après l'abonnement ?",
    a: `Après le paiement, tu reçois le lien du serveur Discord. Tu le rejoins, tu m'envoies ton pseudo Discord, et j'active ton accès sous 24 h. Tu reçois ensuite un email à chaque publication importante.`,
  },
  {
    q: "C'est pour qui ?",
    a: `Pour ceux qui investissent et veulent voir comment j'applique ma lecture du monde à mon propre argent. Ce n'est pas un service de signaux, ni un conseil adapté à ta situation personnelle.`,
  },
  {
    q: "Jusqu'où vas-tu dans le détail de tes positions ?",
    a: `Je partage toutes mes positions, avec la date et le prix d'entrée, ma thèse et ce qui me ferait vendre. J'annonce chaque achat et chaque vente dès que je les ai faits, avec la raison. Le poids de chaque position est indiqué par tranche : principale, moyenne ou petite. Je ne publie ni montants ni pourcentages exacts : OPENACCESS est un partage de mes décisions, pas une allocation à reproduire à l'identique.`,
  },
  {
    q: "Faut-il des connaissances en finance ?",
    a: `Non. Chaque position est expliquée simplement, avec sa thèse et ce qui me ferait vendre.`,
  },
  {
    q: "À quelle fréquence tu publies ?",
    a: `À chaque mouvement, un bilan chaque mois, et des analyses quand l'actualité le justifie.`,
  },
  {
    q: "Faut-il un compte Discord ?",
    a: `Oui. Discord est gratuit, il suffit de créer un compte et de rejoindre le serveur avec le lien reçu après l'abonnement.`,
  },
  {
    q: "Comment résilier ?",
    a: (
      <>
        En quelques clics depuis la page{" "}
        <a
          href="https://www.acinvesting.fr/gerer-mon-abonnement/"
          data-testid="pf-faq-resiliation-link"
          className="text-[#FF6B00] hover:underline underline-offset-4"
        >
          Gérer mon abonnement
        </a>
        . Ton accès reste ouvert jusqu'à la fin de la période payée.
      </>
    ),
  },
  {
    q: "J'ai acheté MULTIPOLAR, j'ai un avantage ?",
    a: `Oui, ton premier mois d'OPENACCESS est offert, sans carte à renseigner. Les instructions t'arrivent par email après l'achat.`,
  },
];

export default function PortfolioFaq() {
  return (
    <section id="faq" data-testid="pf-faq" className="py-24 md:py-32">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="mb-12"
        >
          <span className="micro-label">Questions</span>
          <h2 className="font-display text-4xl sm:text-5xl leading-[1.05] mt-6">
            Les questions <span className="italic text-[#FF6B00]">fréquentes</span>.
          </h2>
        </motion.div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-white/10" data-testid={`pf-faq-item-${i}`}>
              <AccordionTrigger
                data-testid={`pf-faq-trigger-${i}`}
                className="text-left font-mono text-[10px] tracking-[0.06em] leading-tight md:text-sm md:tracking-[0.15em] uppercase text-[#F5F5F0] hover:text-[#FF6B00] hover:no-underline py-6"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#D8D4CC] font-light pb-8 max-w-[70ch]">
                {typeof f.a === "string" ? (
                  f.a.split("\n").map((line, j) => (
                    <p key={j} className="mb-[1em] last:mb-0">{line}</p>
                  ))
                ) : (
                  <p>{f.a}</p>
                )}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
